/* Odds Comfort: UI layer. Header, mega menu, mobile menu, announcement bar, card renderers, recommendation rails,
   quick add, quick view, share, newsletter. */
(function () {
  'use strict';
  var Odds = window.Odds; if (!Odds) return;
  var $ = Odds.$, $$ = Odds.$$;
  var R = Odds.cfg.routes || {};

  /* ---------- renderers (mirror snippets/product-card.liquid) ---------- */
  function priceHTML(p) {
    var from = p.vc > 1 && p.pm > p.p;
    var sale = p.cp && p.cp > p.p;
    return '<span class="price num' + (sale ? ' sale' : '') + '">' + (sale ? '<s>' + Odds.money(p.cp, true) + '</s>' : '') + (from ? '<small>' + Odds.t('from') + '</small> ' : '') + Odds.money(p.p, true) + '</span>';
  }
  function metaLine(p) { return Odds.esc(Odds.cutLabel(p.c)) + ' · ' + Odds.plural('pairs', p.n); }
  function heart(h) { return '<button type="button" class="heart" data-wish="' + Odds.esc(h) + '" aria-pressed="false" aria-label="' + Odds.t('wish_save') + '"><svg class="icon icon-off" aria-hidden="true"><use href="#i-heart"/></svg><svg class="icon icon-on" aria-hidden="true"><use href="#i-heart-filled"/></svg></button>'; }
  function quickBtn(p) {
    if (!p.a) return '<span class="quick is-sold">' + Odds.t('sold_out') + '</span>';
    if (p.vc > 1) return '<button type="button" class="quick" data-quick-view="' + Odds.esc(p.h) + '">' + Odds.t('card_choose') + '</button>';
    return '<button type="button" class="quick" data-quick-add data-variant-id="' + p.v[0].id + '">' + Odds.t('card_quick') + '</button>';
  }
  Odds.render = {
    price: priceHTML,
    card: function (p) {
      if (!p.h) return '';
      var badge = !p.a ? '' : (p.cp && p.cp > p.p) ? '<span class="badge sale">' + Odds.t('card_sale') + '</span>' : p.nw ? '<span class="badge new">' + Odds.t('card_new') + '</span>' : p.vp ? '<span class="badge">' + Odds.t('card_value') + '</span>' : '';
      var dots = (p.sw || []).slice(0, 5).map(function (c) { return '<i style="background:' + Odds.esc(c) + '"></i>'; }).join('');
      return '<article class="card" data-handle="' + Odds.esc(p.h) + '"><div class="img">' + badge + heart(p.h) +
        '<a href="' + Odds.esc(p.u) + '" class="img-link" tabindex="-1" aria-hidden="true"><img class="main" src="' + Odds.esc(Odds.img(p.im, 600)) + '" alt="" loading="lazy" width="600" height="600">' + (p.im2 ? '<img class="alt" src="' + Odds.esc(Odds.img(p.im2, 600)) + '" alt="" loading="lazy" width="600" height="600">' : '') + '</a>' + quickBtn(p) + '</div>' +
        '<h3><a href="' + Odds.esc(p.u) + '">' + Odds.esc(p.t) + '</a></h3><div class="meta"><span>' + metaLine(p) + '</span>' + priceHTML(p) + '</div>' + (dots ? '<div class="dots" aria-hidden="true">' + dots + '</div>' : '') + '</article>';
    },
    upsellCard: function (p) {
      var add = p.a ? (p.vc > 1 ? '<a class="up-add" href="' + Odds.esc(p.u) + '" aria-label="' + Odds.t('card_choose') + '">' + '›' + '</a>' : '<button type="button" class="up-add" data-upsell-add="' + p.v[0].id + '" aria-label="' + Odds.t('upsell_add') + ' ' + Odds.esc(p.t) + '">+</button>') : '';
      return '<div class="up-card"><a class="ph" href="' + Odds.esc(p.u) + '"><img src="' + Odds.esc(Odds.img(p.im, 200)) + '" alt="" loading="lazy" width="200" height="200"></a><div class="up-info"><a href="' + Odds.esc(p.u) + '">' + Odds.esc(p.t) + '</a><span class="muted">' + metaLine(p) + '</span><span class="up-price">' + priceHTML(p) + '</span></div>' + add + '</div>';
    },
    searchCard: function (p) {
      var cat = p.h ? p : (Odds.catalog.byHandle[p.handle] || null);
      if (cat) {
        var qa = cat.a && cat.vc <= 1 ? '<button type="button" class="qa" data-quick-add data-variant-id="' + cat.v[0].id + '" aria-label="' + Odds.t('search_quick') + '">+</button>' : '';
        return '<div class="res"><a href="' + Odds.esc(cat.u) + '"><span class="ph"><img src="' + Odds.esc(Odds.img(cat.im, 400)) + '" alt="" loading="lazy" width="400" height="400"></span><b>' + Odds.esc(cat.t) + '</b><span class="m">' + metaLine(cat) + ' · ' + priceHTML(cat) + '</span></a>' + qa + '</div>';
      }
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      return '<div class="res"><a href="' + Odds.esc(p.url) + '"><span class="ph">' + (img ? '<img src="' + Odds.esc(Odds.img(img, 400)) + '" alt="" loading="lazy">' : '') + '</span><b>' + Odds.esc(p.title) + '</b></a></div>';
    }
  };

  /* ---------- header ---------- */
  var header = $('.site-header');
  function onScroll() { if (header) header.classList.toggle('scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* announcement bar */
  (function () {
    var bar = $('[data-announce]'); if (!bar) return;
    var items = $$('p', bar); if (items.length < 2) return;
    var i = 0, t = null;
    function show(n) {
      var cur = items[i]; i = (n + items.length) % items.length; var nx = items[i];
      if (cur === nx) return;
      cur.classList.add('out'); nx.classList.add('in'); nx.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { nx.classList.remove('in'); }); });
      setTimeout(function () { cur.classList.remove('out'); cur.hidden = true; }, 520);
    }
    items.forEach(function (p, k) { p.hidden = k !== 0; });
    function loop() { clearTimeout(t); if (!Odds.reduced) t = setTimeout(function () { show(i + 1); loop(); }, 4600); }
    loop();
    var prev = $('[data-announce-prev]', bar.parentNode), next = $('[data-announce-next]', bar.parentNode);
    if (prev) prev.addEventListener('click', function () { show(i - 1); loop(); });
    if (next) next.addEventListener('click', function () { show(i + 1); loop(); });
    bar.addEventListener('mouseenter', function () { clearTimeout(t); }); bar.addEventListener('mouseleave', loop);
  })();

  /* ---------- quick add / quick view ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest && e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); e.stopPropagation();
      if (qa.classList.contains('is-loading')) return;
      var txt = qa.textContent; qa.classList.add('is-loading');
      Odds.cart.add([{ id: Number(qa.getAttribute('data-variant-id')), quantity: 1 }], { open: !qa.closest('#search-overlay') }).then(function () {
        qa.classList.remove('is-loading'); qa.classList.add('added'); qa.textContent = '✓';
        setTimeout(function () { qa.classList.remove('added'); qa.textContent = txt; }, 1600);
        if (qa.closest('#search-overlay')) Odds.toast(Odds.t('cart_added'), Odds.t('cart_view'), function () { Odds.overlay.closeAll(true); Odds.cart.open(); });
      }).catch(function () { qa.classList.remove('is-loading'); });
      return;
    }
    var qv = e.target.closest && e.target.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); e.stopPropagation(); openQuickView(qv.getAttribute('data-quick-view')); }
  });

  function openQuickView(handle) {
    var m = $('#quick-view'); if (!m) { location.href = Odds.url('/products/' + handle); return; }
    var box = $('[data-quick-body]', m);
    box.innerHTML = '<div class="qv-loading"><span class="spinner"></span></div>';
    Odds.overlay.open(m, { focus: '[data-overlay-close]' });
    fetch(Odds.url('/products/' + handle + '?view=quick'), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('quick view'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = $('[data-product-root]', doc);
        box.innerHTML = root ? root.outerHTML : '';
        Odds.emit('dom:updated');
        if (Odds.initProduct) Odds.initProduct($('[data-product-root]', box));
        if (Odds.brain) Odds.brain.track('view', { h: handle });
      })
      .catch(function () { Odds.overlay.close(m, true); location.href = Odds.url('/products/' + handle); });
  }
  Odds.quickView = openQuickView;

  /* ---------- recommendation rails ---------- */
  function railItems(el, done) {
    var kind = el.getAttribute('data-rail'), n = Number(el.getAttribute('data-count')) || 4;
    var product = el.getAttribute('data-product') || '';
    var exclude = product ? [product] : [];
    Odds.catalog.load().then(function () {
      if (kind === 'recent') {
        var items = Odds.brain.recent(n + 1, exclude).slice(0, n);
        done(items, null); return;
      }
      if (kind === 'picked' || kind === 'account') {
        var cartH = (Odds.cart && Odds.cart.state.handles) || [];
        var rec = Odds.brain.recommend({ context: 'home', cartHandles: cartH, n: n, exclude: exclude });
        done(rec.items, rec.reason); return;
      }
      if (kind === 'pdp') {
        var cur = Odds.catalog.byHandle[product];
        var curated = (cur && cur.pw) || [];
        var pid = el.getAttribute('data-product-id');
        var nativeP = pid ? Odds.fetchJSON(Odds.url('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=complementary')).catch(function () { return { products: [] }; }) : Promise.resolve({ products: [] });
        var relP = pid ? Odds.fetchJSON(Odds.url('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')).catch(function () { return { products: [] }; }) : Promise.resolve({ products: [] });
        Promise.all([nativeP, relP]).then(function (res) {
          var extra = (res[0].products || []).concat(res[1].products || []).map(function (p) { return p.handle; });
          var rec2 = Odds.brain.recommend({ context: 'pdp', product: product, cartHandles: (Odds.cart && Odds.cart.state.handles) || [], n: n, curated: curated.concat(extra) });
          done(rec2.items, rec2.reason);
        });
        return;
      }
      if (kind === 'like') {
        var c0 = Odds.catalog.byHandle[product];
        var rl = Odds.brain.recommend({ context: 'pdp', product: product, cartHandles: (Odds.cart && Odds.cart.state.handles) || [], n: n * 3, exclude: exclude.concat(Odds._railShown || []) });
        var same = rl.items.filter(function (p) { return !c0 || p.d === c0.d; });
        done(same.concat(rl.items.filter(function (p) { return same.indexOf(p) < 0; })).slice(0, n), { key: 'because_like' }); return;
      }
      if (kind === 'value') {
        var c1 = Odds.catalog.byHandle[product]; if (!c1) { done([], null); return; }
        var per = function (p) { return p.p / Math.max(1, p.n); };
        var bigger = Odds.catalog.items.filter(function (p) { return p.h !== product && p.d === c1.d && p.a && p.n > c1.n && per(p) < per(c1) * 0.99 && (Odds._railShown || []).indexOf(p.h) < 0; })
          .sort(function (a, b) { return (a.c === c1.c ? 0 : 1) - (b.c === c1.c ? 0 : 1) || per(a) - per(b); });
        var seenK = {}, picks = [];
        bigger.forEach(function (p) { var k = p.c + p.pt; if (!seenK[k] && picks.length < n) { seenK[k] = 1; picks.push(p); } });
        done(picks, { key: 'because_value' }); return;
      }
      if (kind === 'cuts') {
        var c2 = Odds.catalog.byHandle[product]; if (!c2) { done([], null); return; }
        var rc = Odds.brain.recommend({ context: 'home', n: 40, exclude: exclude.concat(Odds._railShown || []) });
        var byCut = {}, outc = [];
        rc.items.concat(Odds.catalog.items).forEach(function (p) {
          if (p.d !== c2.d || p.c === c2.c || !p.a || byCut[p.c + ':' + p.pt] || outc.indexOf(p) > -1) return;
          if ((Odds._railShown || []).indexOf(p.h) > -1) return;
          byCut[p.c + ':' + p.pt] = 1; outc.push(p);
        });
        outc.sort(function (a, b) { return (a.pt === c2.pt ? 0 : 1) - (b.pt === c2.pt ? 0 : 1); });
        done(outc.slice(0, n), { key: 'because_cuts' }); return;
      }
      done([], null);
    });
  }
  var railChain = Promise.resolve();
  Odds._railShown = Odds._railShown || [];
  function initRails(scope) {
    $$('[data-rail]', scope || document).forEach(function (el) {
      if (el.__railDone) return; el.__railDone = true;
      railChain = railChain.then(function () {
        return new Promise(function (resolve) {
          railItems(el, function (items, reason) {
            var grid = $('[data-rail-grid]', el);
            if (!items.length) { el.hidden = true; resolve(); return; }
            var rend = el.getAttribute('data-render') === 'upsell' ? Odds.render.upsellCard : Odds.render.card;
            grid.innerHTML = items.map(rend).join('');
            items.forEach(function (p) { if (el.getAttribute('data-product')) Odds._railShown.push(p.h); });
            var r = $('[data-rail-reason]', el);
            if (r && reason) r.textContent = Odds.t(reason.key, reason.vars || {});
            el.hidden = false;
            Odds.emit('dom:updated');
            resolve();
          });
        });
      });
    });
  }
  Odds.initRails = initRails;
  document.addEventListener('DOMContentLoaded', function () { initRails(); });
  if (document.readyState !== 'loading') initRails();
  Odds.on('wishlist:change', function () { $$('[data-rail="wishlist-recs"]').forEach(function (el) { el.__railDone = false; }); });

  /* ---------- share ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('[data-share]'); if (!s) return;
    e.preventDefault();
    var url = s.getAttribute('data-share') || location.href, title = s.getAttribute('data-share-title') || document.title;
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () { /* cancelled */ }); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { Odds.toast(Odds.t('link_copied')); });
  });

  /* ---------- newsletter (ajax post to Shopify customer form) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-newsletter]'); if (!f) return;
    e.preventDefault();
    var email = $('input[type=email]', f), msg = $('[data-news-msg]', f.parentNode) || $('[data-news-msg]');
    var v = (email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { msg.textContent = Odds.t('news_error'); msg.className = 'msg err'; email.focus(); return; }
    var btn = $('button[type=submit]', f); btn.classList.add('is-loading');
    fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } }).then(function (r) {
      btn.classList.remove('is-loading');
      if (r.ok) { msg.textContent = Odds.t('news_ok'); msg.className = 'msg ok'; email.value = ''; } else { msg.textContent = Odds.t('news_error'); msg.className = 'msg err'; }
    }).catch(function () { btn.classList.remove('is-loading'); msg.textContent = Odds.t('news_error'); msg.className = 'msg err'; });
  });

  /* ---------- account page: feed purchase history to the behaviour model ---------- */
  var ph = $('[data-purchased]');
  if (ph) { try { Odds.brain.setPurchased(JSON.parse(ph.getAttribute('data-purchased'))); } catch (e) { /* ignore */ } }

  /* ---------- tidy: re-run wishlist sync on DOM changes ---------- */
  Odds.emit('ui:ready');
})();
